module.exports = __webpack_public_path__ + "static/media/thunderstorm.616d6557.gif";